<template>
    <div class="h-full w-full flex flex-col">
        <ProjectForm mode="create" @created="onCreated" @close="$emit('close')" />
    </div>
</template>

<script>
import ProjectForm from "./form.vue";
export default {
    name: "project-create",
    emits: ["created", "close"],
    components: { ProjectForm, },
    methods: {
        onCreated(msg) {
            this.$emit('created', msg);
        }
    },
}
</script>